import { service } from "./service";

const request = (option: any, parameter: requestotherparameter) => {
  const { url, method, params, data, headersType, responseType } = option;
  const headers = { "Content-Type": headersType || "application/json" };
  const { noLoading, isShowError, keepAlive } = parameter;
  return service({
    url,
    method,
    params,
    data,
    headers: headers,
    responseType: responseType,
    noLoading: noLoading,
    isShowError: isShowError,
    keepAlive: keepAlive
  });
};

export interface requestotherparameter {
  noLoading?: boolean;
  isShowError?: boolean;
  keepAlive?: boolean;
}

export default {
  get: <T = any>(
    option: any,
    parameter: requestotherparameter = {
      noLoading: false,
      isShowError: true,
      keepAlive: false
    }
  ) => {
    return request({ method: "get", ...option }, parameter) as unknown as T;
  },
  post: <T = any>(
    option: any,
    parameter: requestotherparameter = {
      noLoading: false,
      isShowError: true,
      keepAlive: false
    }
  ) => {
    return request({ method: "post", ...option }, parameter) as unknown as T;
  },
  delete: <T = any>(
    option: any,
    parameter: requestotherparameter = {
      noLoading: false,
      isShowError: true
    }
  ) => {
    return request({ method: "delete", ...option }, parameter) as unknown as T;
  },
  put: <T = any>(
    option: any,
    parameter: requestotherparameter = {
      noLoading: false,
      isShowError: true
    }
  ) => {
    return request({ method: "put", ...option }, parameter) as unknown as T;
  }
};
